import { Link } from "react-router-dom";

const categoryShortcuts = [
  {
    label: "电影",
    desc: "大银幕佳作",
    icon: "ri-movie-2-line",
    to: "/category?category=movie",
  },
  {
    label: "电视剧",
    desc: "长篇剧集",
    icon: "ri-tv-2-line",
    to: "/category?category=tv",
  },
  {
    label: "年代剧",
    desc: "时代记忆",
    icon: "ri-history-line",
    to: "/category?genre=%E5%B9%B4%E4%BB%A3",
  },
  {
    label: "类型筛选",
    desc: "悬疑 · 科幻 · 家庭",
    icon: "ri-filter-3-line",
    to: "/category",
  },
];

const genreQuickLinks = [
  "剧情",
  "悬疑",
  "科幻",
  "古装",
  "犯罪",
  "家庭",
  "年代",
  "动作",
  "战争",
  "文艺",
];

export default function CategoryShortcuts() {
  return (
    <section className="w-full bg-background-50 px-4 py-10 md:px-8 md:py-12">
      <div className="mx-auto w-full max-w-6xl">
        <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
          {categoryShortcuts.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 px-4 py-4 transition-colors hover:border-primary-300 hover:bg-primary-50 cursor-pointer"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-600 group-hover:text-background-50">
                <i className={`${item.icon} text-xl`} />
              </span>
              <span className="min-w-0">
                <span className="block text-sm font-bold text-foreground-950">{item.label}</span>
                <span className="mt-0.5 block truncate text-xs text-foreground-600">{item.desc}</span>
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-2">
          <span className="mr-1 text-xs font-medium text-foreground-600">热门类型</span>
          {genreQuickLinks.map((genre) => (
            <Link
              key={genre}
              to={`/category?genre=${encodeURIComponent(genre)}`}
              className="rounded-md bg-secondary-100 px-3 py-1.5 text-xs text-secondary-900 transition-colors hover:bg-secondary-200 cursor-pointer whitespace-nowrap"
            >
              {genre}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}